import { initializeApp } from "firebase/app";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager, memoryLocalCache } from "firebase/firestore";
import { initializeAuth, indexedDBLocalPersistence, browserLocalPersistence } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAIhMfWgd_lOWulH0I4S-0Eq9nIGY4Eg6Y",
  authDomain: "kochbuch-f7545.firebaseapp.com",
  projectId: "kochbuch-f7545",
  storageBucket: "kochbuch-f7545.firebasestorage.app",
  messagingSenderId: "892792716820",
  appId: "1:892792716820:web:d1c90ad7749a68bf537101"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Auth without eager popupRedirectResolver (prevents loading auth/iframe on page load)
const auth = initializeAuth(app, {
  persistence: [indexedDBLocalPersistence, browserLocalPersistence]
});

// Lazy initialize Firestore with Offline Persistence on first access
// (Prevents eager background thread / webchannel / IndexedDB persistence startup in Demo Mode or before login)
const isTest = import.meta.env.MODE === 'test'
let _db: any = null

export const getDb = () => {
  if (!_db) {
    _db = initializeFirestore(app, {
      ignoreUndefinedProperties: true,
      localCache: isTest
        ? memoryLocalCache()
        : persistentLocalCache({
            tabManager: persistentMultipleTabManager()
          })
    })
  }
  return _db
}

const db = new Proxy({} as any, {
  get(_target, prop) {
    const instance = getDb()
    const val = instance[prop]
    return typeof val === 'function' ? val.bind(instance) : val
  },
  set(_target, prop, value) {
    const instance = getDb()
    instance[prop] = value
    return true
  },
  getPrototypeOf() {
    return Object.getPrototypeOf(getDb())
  }
})

export { app, auth, db };